import { Controller } from '@hotwired/stimulus'
import { keepInsideViewport, placePopover } from '@/lib/popover-placement'

const HOVER_CLOSE_DELAY_MS = 150

export default class extends Controller<HTMLElement> {
  static override targets = ['trigger', 'content']

  declare readonly triggerTarget: HTMLButtonElement
  declare readonly contentTarget: HTMLElement

  private pinned = false
  private closing: number | undefined

  override disconnect() {
    window.clearTimeout(this.closing)
  }

  enter({ pointerType }: PointerEvent) {
    if (pointerType !== 'mouse') return
    window.clearTimeout(this.closing)
    if (!this.contentTarget.matches(':popover-open')) this.contentTarget.showPopover()
  }

  leave({ pointerType }: PointerEvent) {
    if (pointerType !== 'mouse' || this.pinned) return
    window.clearTimeout(this.closing)
    this.closing = window.setTimeout(() => this.contentTarget.hidePopover(), HOVER_CLOSE_DELAY_MS)
  }

  pin(event: Event) {
    const open = this.contentTarget.matches(':popover-open')
    if (open && this.pinned) return

    window.clearTimeout(this.closing)
    if (open) event.preventDefault()
    this.pinned = true
  }

  place() {
    placePopover(this.contentTarget, this.triggerTarget, { align: 'start' })
  }

  toggled({ newState }: ToggleEvent) {
    const open = newState === 'open'
    this.triggerTarget.dataset.state = open ? 'open' : 'closed'
    this.triggerTarget.setAttribute('aria-expanded', String(open))
    if (open) keepInsideViewport(this.contentTarget)
    else this.pinned = false
  }
}
